import api from './api';

// Admin-only account management (Anshul, 2026-09-26): list, create, rename/reset-password
// and soft-delete auditor accounts, plus approve/reject a self-registered request.
// Mounted at /api/v1/admin/users (backend/app/api/router.py).
export const usersAPI = {
  // GET "" body: { users: [...active...], pending: [...awaiting approval...] }.
  list: () => api.get('/api/v1/admin/users'),
  // POST "" body echoes { user, restored } -- `restored` is true when this email
  // belonged to a soft-deleted account (UsersPage tells the admin so explicitly).
  create: (payload) => api.post('/api/v1/admin/users', payload),
  update: (userId, payload) => api.patch(`/api/v1/admin/users/${userId}`, payload),
  remove: (userId) => api.delete(`/api/v1/admin/users/${userId}`),
  approve: (userId) => api.post(`/api/v1/admin/users/${userId}/approve`),
  reject: (userId) => api.post(`/api/v1/admin/users/${userId}/reject`),
  // The Navbar's Users badge (polled, not part of the full list fetch).
  pendingCount: () => api.get('/api/v1/admin/users/pending-count'),
};

export default usersAPI;
